












































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Fab extends Vue {
    public fabs: Array<{
        headline: string;
        text: string;
        src: string;
        color: string;
        classes: string;
    }> = [
        {
            headline: "home.liveInteractionTitle",
            text: "home.liveInteraction",
            src: "homepage/interaction.svg",
            color: "white",
            classes: "order-0 d-none d-sm-flex",
        },
        {
            headline: "home.directCommunicationTitle",
            text: "home.directCommunication",
            src: "homepage/whiteboard.svg",
            color: "white",
            classes: "order-1 d-none d-sm-flex",
        },
        {
            headline: "home.ownToolsTitle",
            text: "home.ownTools",
            src: "homepage/import.svg",
            color: "white",
            classes: "order-0 d-none d-sm-flex",
        },
        {
            headline: "home.saveTimeTitle",
            text: "home.saveTime",
            src: "homepage/upload.svg",
            color: "white",
            classes: "order-1 d-none d-sm-flex",
        },
    ];
}
